'use client';

import React, { lazy, useMemo, useState, useEffect } from "react";
import { Image, isNextBuild } from '@/lib/target';
import { BXH_LEAGUES } from "@/contants";
import { LeaguesDropdown } from "@/components/client/LeagueStanding/index.js"
const NoData = lazy(() => import("../NoData"));
const LeagueStandingHeader = lazy(() => import("../LeagueStandingHeader"));

const CupStanding = ({ data, leagueId }) => {
  
  if (!data?.roundScoreItems?.length) {
    return (
      <div className="pb-3">
        <div className="@md:hidden w-full"> 
        {isNextBuild ? (<LeaguesDropdown items={BXH_LEAGUES} itemId={leagueId.id}/>) : (<></>)} 
        </div>
        <NoData />
      </div>
    );
  }

  const rounds = useMemo(() => data.roundScoreItems, [data]);

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (rounds.length > 0) {
      setActiveTab(rounds[0].id);
    }
  }, [rounds]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };  
  
  return (
    <div className="rounded w-full mx-auto mt-4 px-2 @md:px-7 pb-5">
      <>
        <div className="@md:hidden w-full">
        {isNextBuild ? (<LeaguesDropdown items={BXH_LEAGUES} itemId={leagueId.id}/>) : (<></>)} 
        </div>
        </>
      {/* Tabs */}
      <ul id="tabs" className="inline-flex pt-2 w-full border-b mb-4 border-button-blue-bet gap-3 pb-px">
        {rounds.map((item) => {
          switch (item.roundName) {
            case "Qualifying":
              item.roundName = "Vòng loại";
              break;
            case "Round 1":
              item.roundName = "Vòng 1";
              break;
            case "Round 2":
              item.roundName = "Vòng 2";
              break;
            case "Qual. Final":
              item.roundName = "Chung kết vòng loại";
              break;
            case "Round 3":
              item.roundName = "Vòng 3";
              break;
            case "Playoffs":
              item.roundName = "Vòng play-off";
              break;
            case "Group":
              item.roundName = "Vòng bảng";
              break;
            case "1/8 Final":
              item.roundName = "Vòng 1/8";
              break;
            case "Quarterfinals":
              item.roundName = "Tứ kết";
              break;
            case "Semifinals":
              item.roundName = "Bán kết";
              break;
            case "finals":
              item.roundName = "Chung kết";
              break;
            case "League Round":
              item.roundName = "Vòng đấu giải";
              break;
            default:
              item.roundName = item.roundName; // Keep original if no match
          }
                   
          return (
            <li
              key={item.id}
              className={`h-6  text-gray-800 font-semibold flex items-center cursor-pointer justify-center rounded-t hover:bg-button-blue-bet hover:text-white -mb-px ${
                activeTab === item.id ? 'bg-button-blue-bet text-white -mb-px' : 'bg-default-blue '
              }`}
            >
              <button className="w-full px-4" onClick={() => handleTabClick(item.id)}>
              {item.roundName}
              </button>
            </li>
          )
        })}
      </ul>
      <LeagueStandingHeader item={data?.leagues}/>
      <div id="tab-contents">
        {rounds.map((item) => (
          <div key={item.id} className={`${activeTab === item.id ? "" : "hidden"}`}>
            <GroupScoreItems data={item.groupScoreItems} />
          </div>
        ))}
      </div>
    </div>
  );
};




const GroupScoreItems = ({data}) => {

  const groupList = data;

  return groupList && groupList.map((group, index) => {
    
    return (
      <GroupScoreItem data={group} index={index} />
    )
  })
};

const GroupScoreItem = ({data, index}) => {

  const groupColors = [
    {text: '#454444', bg: '#DBE8F1'},
    {text: '#fff', bg: '#E4010B'},
    {text: '#fff', bg: '#004EA0'},
    {text: '#fff', bg: '#00A85D'},
    {text: '#454444', bg: '#FFD600'},
    {text: '#fff', bg: '#2B2C36'},
    {text: '#fff', bg: '#FF6600'},
    {text: '#fff', bg: '#EE34A3'},
    {text: '#fff', bg: '#FFD700'},
    {text: '#fff', bg: '#00A85D'},
    
  ];
  
  const groupName = data.groupName?.split(" ")[1];
  return (
    <div className="text-center mt-3 first:mt-1 dark:bg-midnight-slate">
    <div className="flex w-full grow justify-between h-9">
      <div className="w-72 flex">
        <div className="w-8 mr-4 h-9 flex items-center justify-center">
            <div 
              className="text-center rounded w-8 h-8 flex items-center justify-center"
              style={{color: groupColors[index].text, backgroundColor: groupColors[index].bg}}
              >{groupName}</div>
          </div>
        <div className="w-full text-left flex items-center">Đội</div>
      </div>
      
      <div className="w-28 hidden @md:flex justify-center items-center">Số trận</div>
      <div className="flex w-32 justify-between">
        <div className="w-7 flex justify-center items-center">Thắng</div>
        <div className="w-7 flex justify-center items-center">Hòa</div>
        <div className="w-7 flex justify-center items-center">Bại</div>
      </div>
      {/* <div className="flex w-20 justify-between">
        <div className="w-7 flex justify-center items-center">BT</div>
        <div className="w-7 flex justify-center items-center">BB</div>
        <div className="w-7 flex justify-center items-center">HS</div>
      </div> */}
      <div className="w-10 flex justify-center items-center">Điểm</div>
      {/* <div className="w-24">5 trận gần nhất</div> */}
    </div>
    <ScoreItems data={data.scoreItems} />
  </div>
  );
};


const ScoreItems = ({data}) => {
  
  return (
    
      data.sort((a,b)=> a.rank - b.rank).map((item, index) => (
      <div className="flex w-full grow justify-between h-8 first:bg-white even:bg-white-3 dark:even:bg-dark-slate odd:bg-header-blue dark:odd:bg-midnight-slate items-center text-dark-gray dark:text-white">
         <div className="w-72 flex">
          <div className="w-7 @md:w-8 flex justify-center text-dark-gray dark:text-white font-semibold">{item.rank}</div>
          <div className="@md:w-auto text-left flex ml-4 w-[130px]">
            <span className="mr-2 ">
              <Image alt="Net88" src={item.teams.logo} width={20} height={20} className=" rounded overflow-hidden"/>
            </span>
            <span className="text-ellipsis text-nowrap  overflow-hidden">{item.teams.name}</span>
          </div>
        </div>
        <div className="w-28 font-bold hidden @md:flex justify-center">{item.totalCount}</div>
        <div className="flex w-32 justify-between">
          <div className="w-7">{item.winCount}</div>
          <div className="w-7">{item.drawCount}</div>
          <div className="w-7">{item.loseCount}</div>
        </div>
        {/* <div className="flex w-20 justify-between">
          <div className="w-7">0</div>
          <div className="w-7">0</div>
          <div className="w-7">0</div>
        </div> */}
        <div className="w-10 font-bold">{item.getScore}</div>
      </div>
      ))
      
  );
};
export default React.memo(CupStanding);